import React, { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import useStyles from "./styles";

// HINT: Head contains page title + a cta button
export default function Head(props) {
  const classes = useStyles();

  return (
    <Grid container alignItems="center" className={classes.margin}>
      <Grid container justify="space-between" spacing={1} item>
        <Grid>
          <Typography variant="h2" className={classes.title}>
            {props.title}
          </Typography>
        </Grid>

        <Grid>
          <Button
            className={props.cta2 ? classes.btn2 : ""}
            variant={props.btnVariant}
            color={props.btnColor}
            onClick={props.buttonClick}
          >
            {props.cta}
          </Button>
          {props.cta2 ? (
            <Button
              variant={props.btnVariant2}
              color={props.btnColor2}
              onClick={props.buttonClick2}
            >
              {props.cta2}
            </Button>
          ) : (
            " "
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
